import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SeoMeta from '../components/SeoMeta';
import { ObfuscatedEmail } from '../components/ObfuscatedEmail';

export default function MentionsLegalesPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      <SeoMeta
        title="Mentions Légales"
        description="Mentions légales de Drone Maps édité par BOD CORP (60 rue François Ier, 75008 Paris). SIRET, hébergement, propriété intellectuelle, responsabilité."
        keywords="mentions légales Drone Maps, BOD CORP, éditeur Drone Maps, hébergeur, SIRET 483 320 669"
      />
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sky-600 hover:text-sky-700 mb-8">
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </Link>
        
        <h1 className="text-3xl font-bold text-slate-900 mb-8 font-[Barlow]">Mentions Légales</h1>
        
        <div className="bg-white rounded-xl p-8 shadow-sm space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Éditeur du site</h2>
            <p className="text-slate-600 leading-relaxed">
              Le site <strong>drone-maps.eu</strong> est édité par :<br /><br />
              <strong>BOD CORP</strong><br />
              Entreprise individuelle<br />
              60 RUE FRANCOIS IER<br />
              75008 PARIS<br />
              France<br /><br />
              SIRET : 48332066900037<br />
              Email : <ObfuscatedEmail linkClassName="text-sky-600 hover:underline" />
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Directeur de la publication</h2>
            <p className="text-slate-600 leading-relaxed">
              Le directeur de la publication est le représentant légal de la société BOD CORP.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Hébergement</h2>
            <p className="text-slate-600 leading-relaxed">
              Le site est hébergé par :<br /><br />
              <strong>Emergent</strong><br />
              Service d'hébergement cloud<br />
              Site web : <a href="https://www.emergent.sh" target="_blank" rel="noopener noreferrer" className="text-sky-600 hover:underline">www.emergent.sh</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Propriété intellectuelle</h2>
            <p className="text-slate-600 leading-relaxed">
              L'ensemble du contenu du site drone-maps.eu (textes, images, graphismes, logo, icônes, sons, logiciels, etc.) 
              est la propriété exclusive de BOD CORP ou de ses partenaires et est protégé par les lois françaises 
              et internationales relatives à la propriété intellectuelle.<br /><br />
              Toute reproduction, représentation, modification, publication, transmission, ou plus généralement toute 
              exploitation non autorisée du site ou de ses contenus, que ce soit en tout ou partie, est strictement 
              interdite sans l'accord préalable écrit de BOD CORP.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Données personnelles</h2>
            <p className="text-slate-600 leading-relaxed">
              Les informations concernant la collecte et le traitement des données personnelles sont détaillées 
              dans notre <Link to="/confidentialite" className="text-sky-600 hover:underline">Politique de Confidentialité</Link>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Cookies</h2>
            <p className="text-slate-600 leading-relaxed">
              Le site utilise des cookies. Pour en savoir plus sur leur utilisation et les options de gestion, 
              consultez notre <Link to="/cookies" className="text-sky-600 hover:underline">Politique de Cookies</Link>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Limitation de responsabilité</h2>
            <p className="text-slate-600 leading-relaxed">
              Drone Maps fournit des informations réglementaires à titre indicatif pour aider les opérateurs de drones. 
              Ces informations ne se substituent pas aux publications officielles (AIP, NOTAM, réglementations locales).<br /><br />
              BOD CORP ne saurait être tenue responsable des dommages directs ou indirects résultant de l'utilisation 
              des informations fournies par le site. L'utilisateur est seul responsable de la vérification des 
              informations auprès des autorités compétentes avant tout vol.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Droit applicable</h2>
            <p className="text-slate-600 leading-relaxed">
              Les présentes mentions légales sont soumises au droit français. En cas de litige, et après tentative 
              de résolution amiable, compétence exclusive est attribuée aux tribunaux français.
            </p>
          </section>

          <p className="text-sm text-slate-400 pt-4 border-t border-slate-200">
            Dernière mise à jour : Février 2026
          </p>
        </div>
      </div>
    </div>
  );
}
